export { default as Home }     from './Home';
export { default as Blog }     from './Blog';
export { default as Trinkets } from './Trinkets';
